import React from 'react'
import Class from '../../modules/Class'

const ClassPage = () => {
    return <Class />
}

export default ClassPage